class InvestmentApi {
    getListByCurrentBusiness() {
        return api.call('get', apiUrl + 'investments/currentBusiness/')
            .then(({ data }) => data);
    }
    get(id) {
        return api.call('get', apiUrl + 'investments/' + id)
            .then(({ data }) => data);
    }
    create(data) {
        return api.call('post', apiUrl + 'investments', data)
            .then(({ data }) => data);
    }
    update(data) {
        return api.call('put', apiUrl + 'investments/' + data.id, data)
            .then(({ data }) => data);
    }
    delete(id) {
        return api.call('delete', apiUrl + 'investments/' + id)
            .then(({ data }) => data);
    }
}

export default InvestmentApi;
